import {
	getModule,
	Module,
	VuexModule,
	Mutation,
	Action,
} from 'vuex-module-decorators';
import store from '@/store';
import programz from '../programz';
import { ProgramData, softwareTypes, UpdateProgramSubmission, AddProgramSubmission } from '../models.def';
import { Dictionary } from 'vue-router/types/router';
@Module({
	namespaced: true,
	name: 'programx',
	store,
	dynamic: true,
})
class ProgramsModule extends VuexModule {

	public allPrograms: ProgramData[] = [];

	public get groupedPrograms(): Dictionary<ProgramData[]> {
		const dic = softwareTypes.reduce(
			(obj, key) => {
				obj[key] = this.allPrograms.filter(
					(data) => data.softwareType === key,
				);
				return obj;
			}, {} as Dictionary<ProgramData[]>);
		return dic;
	}

	@Mutation
	public m_updateAllPrograms(programDatas: ProgramData[]) {
		this.allPrograms = programDatas;
	}

	@Action
	public updateAllPrograms(programs: ProgramData[]) {
		this.m_updateAllPrograms(programs);
	}

	@Action
	public addProgram(submission: AddProgramSubmission) {
		return programz.addProgram(submission);
	}
	@Action
	public updateProgram(submission: UpdateProgramSubmission) {
		return programz.updateProgram(submission);
	}

	@Action
	public getAccountsUsingProgram(programId: string) {
		return programz.getAccountsUsingProgram(programId);
	}

	@Action
	public deleteProgram(programId: string) {
		return programz.deleteProgram(programId);
	}

}


export default getModule(ProgramsModule);
